import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Award, ArrowRight } from 'lucide-react';

const CorporateTraining = () => {
  useEffect(() => {
    document.title = 'Kurumsal Eğitimler | akarma';
  }, []);

  const trainings = [
    {
      title: 'Başarılı bir hayat için etkin iletişim ve farkındalık',
      description: 'İletişim becerilerini geliştirerek kişisel ve profesyonel başarı için gerekli farkındalık kazandıran eğitim.'
    },
    {
      title: 'Stres yönetimi ile mutlu bir yaşam',
      description: 'Stresle başa çıkma teknikleri, denge sağlama ve mutlu bir yaşam için stratejiler.'
    },
    {
      title: 'Dört farklı dilde iletişimde yetkinleşmek',
      description: 'Farklı iletişim stillerini anlamak ve her biriyle etkili iletişim kurabilmek.'
    },
    {
      title: 'NLP ve değişim',
      description: 'Noro-Linguistik Programlama teknikleri ile kişisel ve örgütsel dönüşüm sağlama.'
    },
    {
      title: 'Duygusal zeka ve liderlik',
      description: 'Duygusal zeka yetkinliklerini geliştirerek etkili liderlik becerileri kazanma.'
    },
    {
      title: 'Şampiyonlar takımını yaratmak',
      description: 'Yüksek performanslı takımlar oluşturma, takım dinamiklerini yönetme ve motivasyon stratejileri.'
    },
    {
      title: 'NLP ve yaratıcılık',
      description: 'NLP teknikleri kullanarak yaratıcı düşünme kapasitesini geliştirme.'
    },
    {
      title: 'Çatışma yönetimi ve sorun çözme teknikleri',
      description: 'Çatışmaları yapıcı şekilde yönetme ve etkili problem çözme becerileri.'
    },
    {
      title: 'Etkili yönetici mi? Yetkin lider mi?',
      description: 'Yöneticilik ve liderlik arasındaki farkı anlamak, liderlik becerilerini geliştirmek.'
    },
    {
      title: 'Gülen müşteri, gülen şirket',
      description: 'Müşteri memnuniyeti, müşteri deneyimi yönetimi ve sadakat oluşturma stratejileri.'
    },
    {
      title: 'Sonuç odaklı satış ve satışta müşteri analizi',
      description: 'Müşteri profillerini anlama, etkili satış teknikleri ve sonuç almaya odaklı yaklaşımlar.'
    },
    {
      title: 'Sunum teknikleri ve beden dili',
      description: 'Etkili sunum yapma, beden dili kullanımı ve ikna edici konuşma becerileri.'
    },
    {
      title: 'Temel yönetim becerileri',
      description: 'Planlama, organizasyon, koordinasyon, kontrol ve karar verme gibi temel yönetim fonksiyonları.'
    },
    {
      title: 'Mutluluk',
      description: 'İş hayatında mutluluğu yakalamak, pozitif psikoloji ve iş yaşam dengesi.'
    },
    {
      title: 'Rengarenk ilişki yönetimi',
      description: 'İş yerinde sağlıklı ilişkiler kurma, ilişki yönetimi ve empati geliştirme.'
    },
    {
      title: 'Duyguların yönetimi',
      description: 'Duyguları tanıma, anlama ve etkili şekilde yönetme becerileri.'
    },
    {
      title: 'Mutlu, güçlü ve özgür bir yaşam için',
      description: 'Kişisel gelişim, özgüven artırma ve yaşam kalitesini yükseltme stratejileri.'
    },
    {
      title: 'Yoga ile uyumlu bir hayat',
      description: 'Yoga felsefesi, zihin-beden bağlantısı ve dengelenmiş bir yaşam için pratikler.'
    }
  ];

  const benefits = [
    'Uluslararası standartlar içeren eğitim programları',
    'Kurumun niteliklerine uygun özelleştirilmiş içerikler',
    '20+ yıllık deneyim ve uzmanlık',
    'İnteraktif ve katılımcı odaklı metodoloji',
    'Teorik bilgi ve pratik uygulamaların dengesi',
    'Eğitim sonrası destek ve tak ip'
  ];

  return (
    <div className="corporate-training pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Award size={64} className="mx-auto mb-6" />
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Kurumsal Eğitimler</h1>
            <p className="text-xl md:text-2xl opacity-90">
              Kurumsal firmaların yönetici ve çalışanları için hazırlanmış profesyonel eğitim programları
            </p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-xl text-gray-700 leading-relaxed mb-12">
              Akarma, Türk iş dünyasının ihtiyaçlarını karşılamaya yönelik bütünüyle kurumun 
              niteliklerine uygun uluslararası standartlar içeren eğitim, ölçme-değerlendirme ve 
              yönetim geliştirme hizmetleri sunmaktadır.
            </p>
          </div>
        </div>
      </section>

      {/* Training List */}
      <section className="pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Eğitim Programlarımız</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {trainings.map((training, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-lg card-hover border-l-4 border-akarma-blue">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">{training.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{training.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Neden Akarma Kurumsal Eğtimleri?</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-xl shadow-md">
                  <div className="w-8 h-8 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <p className="text-gray-700 font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Special Programs */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Öne Çıkan Eğitimler</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-8 rounded-2xl text-white">
                <h3 className="text-2xl font-bold mb-4">Stratejik Liderlik Eğitimi</h3>
                <ul className="space-y-3">
                  <li className="flex items-start space-x-2">
                    <span className="text-2xl">•</span>
                    <span>Kurumun temel değerlerini kavrayarak hareket etme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-2xl">•</span>
                    <span>Stratejik planı analiz etme ve liderlik stillerini ortaya koyma</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-2xl">•</span>
                    <span>Kurum kültürünün stratejisi ile ilişkisini yönetme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-2xl">•</span>
                    <span>Etkin liderlik yaklaşımın yukarıdan aşağıya indirgenmesi</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-2xl">•</span>
                    <span>Vizyon ve misyon ile ilgili ilham verme</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-purple-600 to-purple-700 p-8 rounded-2xl text-white">
                <h3 className="text-2xl font-bold mb-4">Yönetici Koçluğu</h3>
                <p className="text-lg leading-relaxed mb-4">
                  Bu seminerde, katılımcıların farklı davranış ve iletişim kalıplarını öğrenerek 
                  yepyeni bir farkındalık kazanmaları hedeflenir.
                </p>
                <p className="text-lg leading-relaxed">
                  Kişiler böylelikle, profesyonel ve özel hayat içinde karşılaştıkları tüm bireyleri 
                  daha iyi anlama ve tanıma şansına sahip olacakları için daha uyumlu, verimli ve 
                  mutlu ilişkiler geliştirebilirler.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Şirketiniz İçin Gerekli Eğitimleri Seçin</h2>
            <p className="text-xl text-gray-600 mb-8">
              Kurumunuzun ihtiyaçlarına özel eğitim programları hazırlıyoruz. 
              Detaylı bilgi ve teklif almak için bizimle iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-lg"
            >
              Bize Ulaşın
              <ArrowRight size={24} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CorporateTraining;